import React from "react";
import MobileProjectList from "../components/MobileProjectList";
import { CreateProjectModal } from "../components/modals/CreateProjectModal";

const MobileProjectsPage = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <CreateProjectModal isOpen={open} handleClose={handleClose} />
      <MobileProjectList openCreateProjectModal={handleOpen} />
    </div>
  );
};

export default MobileProjectsPage;
